import { useUser } from '../context/user'
import { Redirect } from 'react-router-dom'

const PublicRoute = ({ Component }) => {
    const { isSignedIn } = useUser()
    return isSignedIn ? <Redirect to="/" /> : <Component />
}

export default PublicRoute
